import { Skeleton } from "@fullscript/aviary-web";

import { Arrange } from "@aviary";

const PatientInfoBlockSkeleton = () => {
  return (
    <Arrange isVertical isFullWidth justify="center" alignment="center">
      <Skeleton variant="typography" isFullWidth />
      <Skeleton variant="typography" width="65%" />
      <Skeleton variant="typography" isFullWidth />
      <Skeleton variant="typography" width="45%" />
    </Arrange>
  );
};

export { PatientInfoBlockSkeleton };
